/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Col_Restore_ShortInputs */

const vi_confirm_return_col_restore_short = /** @type {(inputs: Confirm_Return_Col_Restore_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhập lại`)
};

/**

* @param {Confirm_Return_Col_Restore_ShortInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_col_restore_short = /** @type {((inputs?: Confirm_Return_Col_Restore_ShortInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Col_Restore_ShortInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_col_restore_short(inputs)
});